export type PaddleCustomData = {
  user_id: number;
  tolt_referral?: string;
  tolt_customer_id?: string;
};

// Tolt's Paddle Classic webhook links a payment to the partner through
// custom_data.tolt_referral (set by tolt.js from the referral cookie).
// tolt_customer_id is kept for our own webhook to back-fill the user.
export const buildPaddleCustomData = (
  userId: number,
  storedToltCustomerId?: string
): PaddleCustomData => {
  const toltReferral = window.tolt_referral;
  const toltCustomerId =
    storedToltCustomerId || (window.tolt_data && window.tolt_data.customer_id);

  return {
    user_id: userId,
    ...(typeof toltReferral === "string" && toltReferral
      ? { tolt_referral: toltReferral }
      : {}),
    ...(toltCustomerId ? { tolt_customer_id: toltCustomerId } : {}),
  };
};
